import controller from './double-opt-dialog.controller';
import './double-opt-dialog.component.less';

export default {
  controller,
  template: require('./double-opt-dialog.html')
};



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/double-opt-dialog.component.ts